export enum MaintenanceSort {
  RoomNumber = 'roomNumber',
  Status = 'status',
  State = 'state',
  StartTime = 'fromTime',
  EndTime = 'toTime',
  Reason = 'reason'
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/shared/enum/maintenanceSort.ts